const doc = [({"se":({"models":({"team_survey":({"new":"Ny", "completed":"Färdig"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;